var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { THEMA_SCHEME_TO_CODETABLE } from "../../utils/onixTables";
import { fetchOnixCodetableItems } from "../../api/onixService";
export var useThemaOptions = function () {
    var ky = useOkapiKy();
    var _a = useState({}), themaSelectOptionsByRow = _a[0], setThemaSelectOptionsByRow = _a[1];
    var onThemaAsyncFilter = function (rowIndex, schemeValue) {
        return function (filterValue) { return __awaiter(void 0, void 0, void 0, function () {
            var codetableNumber, onixCodetableItems, options;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        codetableNumber = THEMA_SCHEME_TO_CODETABLE[schemeValue];
                        if (!codetableNumber)
                            return [2 /*return*/];
                        return [4 /*yield*/, fetchOnixCodetableItems(ky, {
                                onixCodetableNumber: codetableNumber,
                                searchText: filterValue,
                                limit: 50,
                            })];
                    case 1:
                        onixCodetableItems = (_a.sent()).onixCodetableItems;
                        options = onixCodetableItems.map(function (item) {
                            var _a, _b;
                            return ({
                                value: (_a = item.value) !== null && _a !== void 0 ? _a : "",
                                label: item.description
                                    ? "".concat(item.value, " \u2014 ").concat(item.description)
                                    : ((_b = item.value) !== null && _b !== void 0 ? _b : ""),
                            });
                        });
                        setThemaSelectOptionsByRow(function (previous) {
                            var _a;
                            return (__assign(__assign({}, previous), (_a = {}, _a[rowIndex] = options, _a)));
                        });
                        return [2 /*return*/];
                }
            });
        }); };
    };
    var clearThemaOptionsForRow = function (rowIndex) {
        setThemaSelectOptionsByRow(function (previous) {
            var next = __assign({}, previous);
            delete next[rowIndex];
            return next;
        });
    };
    return {
        themaSelectOptionsByRow: themaSelectOptionsByRow,
        onThemaAsyncFilter: onThemaAsyncFilter,
        clearThemaOptionsForRow: clearThemaOptionsForRow,
        themaOptionsMap: themaSelectOptionsByRow,
        onThemaFilter: onThemaAsyncFilter,
        clearThemaRow: clearThemaOptionsForRow,
    };
};
